module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec02_pc_034fdff214e98f3c40a2771417848999.jpg";